import { memo } from 'react';
import { useSwipeable } from 'react-swipeable';
import { useLocaleStore } from '@/store';
import { useThemeToken } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { LuChevronRight, LuChevronLeft } from 'react-icons/lu';

import './styles.css';

export interface WeekChangerProps {
  currentDot: number;
  weekDates: string[];
  onPressLeft: () => void;
  onPressRight: () => void;
  onPressDot: (index: number) => void;
}

export const WeekChanger = memo((props: WeekChangerProps) => {

  const [t] = useTranslation();
  const isRTL = useLocaleStore(state => state.dir) === 'rtl';
  const { colorPrimary } = useThemeToken();

  const swipeable = useSwipeable({
    onSwiping: (e) => {
      if (e.first) {
        if (e.dir === 'Left') props.onPressLeft();
        else if (e.dir === 'Right') props.onPressRight();
      }
    },
  });

  return (
    <div
      style={{ backgroundColor: colorPrimary }}
      className="week-changer-container rounded-none lg:rounded-lg !mt-auto lg:!mt-0 !mb-0 lg:!mb-auto"
      {...swipeable}
    >
      <button
        type="button"
        onClick={props.onPressRight}
        className="week-changer-buttons"
      >
        {isRTL ? <LuChevronRight className="text-white text-2xl" /> : <LuChevronLeft className="text-white text-2xl" />}
      </button>
      <span className="text-sm text-white font-medium">
      {t('common:labels.page')} {props.currentDot + 1} {t('common:labels.of')} {props.weekDates.length}
      </span>
      <button
        className="week-changer-buttons"
        type="button"
        onClick={props.onPressLeft}
      >
        {isRTL ? <LuChevronLeft className="text-white text-2xl" /> : <LuChevronRight className="text-white text-2xl" />}
      </button>
    </div>
  );
});

export default WeekChanger;
